import { DriverEntity } from "./driverEntity";
import { TruckEntity } from "./truckEntity";

export type PickingList = {
  truck: TruckEntity;
  driver: DriverEntity;
  course_number?: number | null;
  dispatches: DateList[];
}

export type DateList = {
  date: string;
  shippers: ShipperList[];
}

export type ShipperList = {
  shipper_name: string,
  unloads: UnloadList[]
}

export type UnloadList = {
  unloading_name: string,
  items: ItemList[]
  slip_numbers?: string;
  slip_number_list?: string[];
}

export type ItemList = {
  item_carrier_company: string;
  item_code: string;
  item_count: number;
  item_name: string,
  item_lot_number?: string | null;
  item_packing_style: string;
  item_memo?: string | null;
  loading_time_range_start: string;
  unloading_address: string;
  unloading_time_range_start: string;
  empty_id?: number;
}

/** ピッキングリスト 1 ページあたりの最大商品行数（issue #259）。 */
export const PICKING_PAGE_ROWS = 20;

/** 1 納品先の商品行数から、20 行分割後のページ数を返す（最低 1 ページ）。 */
export function pickingUnloadPageCount(itemCount: number): number {
  return Math.max(1, Math.ceil(itemCount / PICKING_PAGE_ROWS));
}

/**
 * ピッキングリスト全体の総ページ数を算出する（納品先ごとに 20 行分割）。
 * Component（onCountChange 通知）と Presenter（フッターの x/y 表示）の両方から共用する。
 */
export function computePickingPageCount(models: PickingList[]): number {
  return models.reduce((total, course) => {
    if (course.dispatches.length === 0) return total + 1;
    const courseCount = course.dispatches.reduce((dispatchTotal, loadingDate) => {
      const dateCount = loadingDate.shippers.reduce(
        (shipperTotal, shipper) => shipperTotal
          + shipper.unloads.reduce((unloadTotal, unload) => unloadTotal + pickingUnloadPageCount(unload.items?.length ?? 0), 0),
        0,
      );
      return dispatchTotal + dateCount;
    }, 0);
    return total + courseCount;
  }, 0);
}
